/**
 * Random integer usable as a client-side-only placeholder id.
 * These ids never leave the browser - they are only used as React keys and local lookup keys.
 *
 * The value is always above 2**32, for two reasons:
 * - it can never collide with a real (much smaller) id coming from the API,
 * - object keys below 2**32 - 1 are array indices, and would therefore be enumerated before -
 *   and sorted against - the real ids in records keyed by id.
 */
export const randomNumericId = (): number => {
  const [high, low] = crypto.getRandomValues(new Uint32Array(2))

  // 1 <= high < 2**21 and 0 <= low < 2**32, so the result fits into [2**32, Number.MAX_SAFE_INTEGER]
  return ((high % (2 ** 21 - 1)) + 1) * 2 ** 32 + low
}

/** Opaque random string id with 128 bits of entropy. */
export const randomStringId = (): string =>
  Array.from(crypto.getRandomValues(new Uint32Array(4)), part => part.toString(16).padStart(8, "0")).join("")
